import { rem } from '../util';

export const fontSizes = {
  xs: rem(12), // '0.75rem'
  sm: rem(14), // '0.875rem'
  base: rem(16), // '1rem'
  lg: rem(18), // '1.125rem'
  xl: rem(20), // '1.25rem'
  '2xl': rem(22), // '1.375rem'
  '3xl': rem(24), // '1.5rem'
  '4xl': rem(26), // '1.625rem'
  '5xl': rem(28), // '1.75rem'
  '6xl': rem(30), // '1.875rem'
  '7xl': rem(32), // '2rem'
};
